
function shareWithGuestsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/share-with-guests/share-with-guests-dialog.html?$$REVISION$$'
  }
}

export { shareWithGuestsDialog }
